import { render, staticRenderFns } from "./SanityMarkdownContent.vue?vue&type=template&id=f6f9f99c&scoped=true&"
import script from "./SanityMarkdownContent.vue?vue&type=script&lang=ts&"
export * from "./SanityMarkdownContent.vue?vue&type=script&lang=ts&"
import style0 from "./SanityMarkdownContent.vue?vue&type=style&index=0&id=f6f9f99c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f9f99c",
  null
  
)

export default component.exports